import React from "react";
import { components } from "../../../../../api/spec";

interface CompletedSetupsListProps {
  candidates: components["schemas"]["EventCandidateSummarySchema"][];
  numRounds?: number;
  currentRound?: number;
}

const CompletedSetupsList: React.FC<CompletedSetupsListProps> = ({
  candidates,
  numRounds = 1,
  currentRound = 1,
}) => {
  const getHeaderText = () => {
    if (numRounds > 1) {
      if (currentRound < numRounds) {
        return `The following setups have been sent out, Round ${currentRound} is complete. Go to Round ${currentRound + 1}`;
      }
      return `The following setups have been sent out, Round ${currentRound} is complete.`;
    }
    return "The following setups have been sent out.";
  };

  return (
    <div className="mb-8 divide-y divide-white/20">
      <h3 className="text-white font-medium text-md mt-4 mb-4">
        {getHeaderText()}
      </h3>
      {candidates.map((candidate) => (
        <div
          key={candidate.guid}
          className="flex items-center justify-between bg-black/30 backdrop-blur-sm py-3 px-4"
        >
          <div className="flex-1">
            <h3 className="text-white/60 font-medium text-md">
              {candidate.user_1_full_name} & {candidate.user_2_full_name}
            </h3>
            {candidate.is_manually_created && (
              <p className="text-white/60 text-sm mt-1">Manual setup</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

CompletedSetupsList.defaultProps = {
  numRounds: 1,
  currentRound: 1,
};

export default CompletedSetupsList;
